import { Stack, Text } from "@chakra-ui/react";
import { Content } from "./Content";
import { Layout } from "./layout";

export function BlockedUserState() {

  return (
    <Layout>
      <Content sx={{
        minHeight: 'calc(100dvh - 66px)',
        backgroundColor: '#000',
        padding: '100px 20px',
        backgroundImage: `url('${process.env.NEXT_PUBLIC_API_URL}/images/decoration.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right'
      }}>
        <Stack gap="10px" flex="1" alignItems="center" justifyContent="center" maxWidth="600px" margin="0 auto">
          <Text fontSize="28px" mb="10px" fontWeight="600" color="#fff">Access Disabled</Text>
          <Text fontSize="20px" fontWeight="400" color="#fff" textAlign="center">Sorry, but your access was disabled.</Text>
          <Text fontSize="20px" fontWeight="400" color="#fff" textAlign="center">
            Please contact the Principal Investigator (PI) or User Admin to review your access to the ENGYS Customer Portal.
          </Text>
        </Stack>
      </Content>
    </Layout >
  )
}